import * as React from 'react'

const SvgBackToTopIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 8.125l-6.25 6.25.881.881L10 9.894l5.369 5.362.881-.881L10 8.125zm-7.5-3.75h15v1.25h-15v-1.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgBackToTopIcon
